/**
 * Centralized Auth API Configuration
 * 
 * Single source of truth for all auth API endpoints
 */

const isDev = import.meta.env.DEV;

export const AUTH_API_BASE_URL = isDev
  ? 'http://localhost:8789'
  : 'https://auth.pivot.is';

export const AUTH_API_ENDPOINTS = {
  // Email/Password Auth
  register: `${AUTH_API_BASE_URL}/register`,
  login: `${AUTH_API_BASE_URL}/login`,
  logout: `${AUTH_API_BASE_URL}/logout`,
  me: `${AUTH_API_BASE_URL}/me`,
  refresh: `${AUTH_API_BASE_URL}/refresh`,
  
  // Password Reset
  forgotPassword: `${AUTH_API_BASE_URL}/forgot-password`,
  resetPassword: `${AUTH_API_BASE_URL}/reset-password`,
  
  // OAuth
  googleAuthorize: `${AUTH_API_BASE_URL}/oauth/google/authorize`,
  googleCallback: `${AUTH_API_BASE_URL}/oauth/google/callback`,
  microsoftAuthorize: `${AUTH_API_BASE_URL}/oauth/microsoft/authorize`,
  microsoftCallback: `${AUTH_API_BASE_URL}/oauth/microsoft/callback`,
  githubAuthorize: `${AUTH_API_BASE_URL}/oauth/github/authorize`,
  githubCallback: `${AUTH_API_BASE_URL}/oauth/github/callback`,
  xAuthorize: `${AUTH_API_BASE_URL}/oauth/x/authorize`,
  xCallback: `${AUTH_API_BASE_URL}/oauth/x/callback`,
  oauthExchange: `${AUTH_API_BASE_URL}/oauth/exchange`,
  
  // Phone Auth
  phoneSendCode: `${AUTH_API_BASE_URL}/phone/send-code`,
  phoneVerifyCode: `${AUTH_API_BASE_URL}/phone/verify-code`,
  phoneLogin: `${AUTH_API_BASE_URL}/phone/login`,

  // Email verification
  verifyEmail: `${AUTH_API_BASE_URL}/email/verify`,
  resendVerification: `${AUTH_API_BASE_URL}/email/resend-verification`,
  
  // Magic Link (passwordless)
  magicLinkSend: `${AUTH_API_BASE_URL}/magic-link/send`,
  magicLinkVerify: `${AUTH_API_BASE_URL}/magic-link/verify`,
} as const;

export const FRONTEND_URL = isDev
  ? 'http://localhost:5179'
  : 'https://pivot.is';

export const OAUTH_CALLBACK_URL = `${FRONTEND_URL}/oauth/callback`;

